<template>
  <PageListLayout @reset-filter="resetFilter">
    <template slot="header_right">
      <v-list-item three-line>
        <v-layout align-center>
          <v-img
            max-height="150"
            max-width="150"
            :src="BaoCaoPic"
            class="mr-4"
          ></v-img>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1 black--text">
              BÁO CÁO HỆ THỐNG</v-list-item-title
            >
            <v-list-item-subtitle>Báo cáo khiếu nại</v-list-item-subtitle>
          </v-list-item-content>
        </v-layout>
      </v-list-item>
        <div class="d-flex">
        <v-tooltip>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-1 mt-12" icon v-on="on" @click="exportExcel()">
              <v-icon> mdi-file-export-outline </v-icon>
            </v-btn>
          </template>
          <span>Xuất Excel</span>
        </v-tooltip>
      </div>
    </template>
    <template slot="filter">
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.year"
          placeholder="Chọn năm"
          auto-select-first
          :items="years"
          outlined
          solo
          dense
          hide-details="auto"
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.month"
          :items="this.monthList"
          placeholder="Chọn tháng"
          item-text="name"
          item-value="id"
          solo
          outlined
          dense
          hide-details="auto"
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.staff_id"
          :items="employers"
          label="Nhân viên phụ trách"
          item-text="name"
          item-value="id"
          multiple
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </div>
      <div class="mt-4">
        <v-autocomplete
          v-model="formSearch.area_id"
          :items="areasData"
          label="khu vực"
          item-text="name"
          item-value="id"
          multiple
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </div>
    </template>
    <CustomTable
      :headers="headers"
      :items="desserts"
      :page.sync="page"
      :items-per-page=50
      :loading="isloading"
      hide-default-footer
      @change-page="changePage"
      classPaging="mt-2"
    ></CustomTable>
  </PageListLayout>
</template>
<script>
import BaoCaoPic from "../../../assets/images/baocao.svg";
import Report from "@/api/report.js";
import { saveAs } from "file-saver";
import { monthList } from "@/constants/time";
import { generateArrayOfYears } from "@/utils/date.js";
import { getAllAreas } from "@/api/khuvuc";
import { getNhanVienKinhDoanh } from "@/api/nhanvien";
export default {
  data() {
    return {
      page: 1,
      monthList,
      BaoCaoPic,
      areasData: [],
      employers: [],
      years: generateArrayOfYears(10),
      isloading: false,
      search: "",
      calories: "",
      data: {},
      data_render: [],
      desserts: [],
      formSearch: {
        year: new Date().getFullYear(),
        month: "",
        staff_id: [],
        area_id: [],
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: "Năm", value: "year" },
        { text: "Tháng", value: "month" },
        { text: "Nhân viên", value: "staff" },
        { text: "khu vực", value: "area" },
        {
          text: "Nhóm khách hàng",
          align: "start",
          value: "type",
          filter: (value) => {
            if (!this.calories) return true;
            return value < parseInt(this.calories);
          },
        },
        {
          text: "Số lượng khiếu nại từ khách hàng",
          value: "complaint_quantity",
        },
        {
          text: "Số khiếu nại được giải quyết triệt để",
          value: "complaint_done",
        },
        {
          text: "Tổng thời gian giải quyết khiếu nại từ khách hàng",
          value: "complaint_finish_time",
        },
        { text: "Số lượng yêu cầu từ khách hàng", value: "request_quantity" },
        {
          text: "Số lượng yêu cầu đã được giải quyết triệt để ",
          value: "request_done",
        },
        {
          text: "Tổng thời gian giải quyết yêu cầu từ khách hàng",
          value: "request_finish_time",
        },
        {
          text: "Tổng số yêu cầu khiếu nại được phản hồi trong ngày",
          value: "total_done",
        },
        // { text: "Tỷ lệ khiếu nại được giải quyết triệt để ", value: "prob_complaint_done" },
        // { text: "Thời gian trung bình giải quyết khiếu nại", value: "average_complaint_time" },
        // { text: "Tỷ lệ yêu cầu của khách hàng được giải quyết triệt để", value: "prob_request_done" },
        // { text: "Thời gian trung bình giải quyết yêu cầu từ khách hàng", value: "average_request_time" },
        // { text: "Tỷ lệ phản hồi yêu cầu, khiếu nại khách hàng trong ngày ", value: "prob_complaint_feedback  " },
      ];
    },
  },
  created() {
    this.isloading = true;
    this.getAllEmployee();
    this.getAllArea();
    this.getData();
    this.isloading = false;
  },
  methods: {
    changePage(val) {
      this.page = val;
    },
    async getAllEmployee() {
      try {
        const res = await getNhanVienKinhDoanh();
        this.employers = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getAllArea() {
      let data = await getAllAreas();
      this.areasData = data;
    },
    async getData() {
      try {
        this.isloading = true;
        const res = await Report.getReportComplaint(this.formSearch);
        this.data = res.data;
        this.desserts=[];
        this.loadData(this.data);
        this.isloading = false;
      } catch (error) {
        console.error(error);
      }
    },
    loadData(tagert) {
      tagert.forEach((item) => {
        if (item.staff == null) {
          item.staff = "null";
        }
        if (item.area == null) {
          item.area = "null";
        }
        this.desserts.push({
          year: item.year,
          month: item.month,
          staff: item.staff,
          area: item.area,
          type: item.type,
          complaint_quantity: item.complaint_quantity,
          complaint_done: item.complaint_done,
          complaint_finish_time: item.complaint_finish_time,
          request_quantity: item.request_quantity,
          request_done: item.request_done,
          request_finish_time: item.request_finish_time,
          total_done: item.total_done,
          // prob_complaint_done: item.prob_complaint_done,
          // average_complaint_time: item.average_complaint_time,
          // prob_request_done: item.prob_request_done,
          // average_request_time: item.average_request_time,
          // prob_complaint_feedback: item.prob_complaint_feedback
        });
      });
    },
    async exportExcel() {
      try {
        const res = await Report.exportCompailt(this.formSearch);
        if (res && res.isDone) {
          saveAs(new Blob([res.data]), "BaoCaoKhieuNaiYeuCau.xlsx");
        }
        this.$toast.success("Xuất báo cáo thành công", {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        this.$toast.error("lỗi" + " " + error, {
          position: "top-center",
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          message: error,
        });
      }
    },
    resetFilter() {
      this.formSearch = this.$options.data.call(this).formSearch;
    },
  },
  watch: {
    formSearch: {
      handler: function (newValue) {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>

<style>
.app {
  margin-top: 10px;
}
</style>